import { updatePartInputSchema } from './update-input.js';
/**
 * Derived from the very schema `updatePart` validates, not from the costing form: a GL account
 * reachable by import or another tab still has to appear here, so it cannot ship writable by any
 * `part:edit` holder, and dropping a field from the costing tab cannot silently un-gate it.
 */
export const PART_ACCOUNTING_FIELD_KEYS = Object.keys(updatePartInputSchema.shape).filter((key) => key.endsWith('AccountId'));
//# sourceMappingURL=accounting-field-keys.js.map